import {Roster, User} from "@/api/dto/dto";
import {Encounter} from "@/api/dto/encounter";
import {Client} from "@/api/dto/client-profile";

export enum FormCodeBinding {
    DSAMH_CRF_ADMISSION_FORM = "DSAMH_CRF_ADMISSION_FORM",
    DSAMH_CRF_DISCHARGE_FORM = "DSAMH_CRF_DISCHARGE_FORM",

    TEST_1 = "TEST_1", //Test CodeBindings
    TEST_2 = "TEST_2", //Test CodeBindings
    TEST_3 = "TEST_3"  //Test CodeBindings
}

export enum RosterFormCodeBinding {
    CLIENT_ADDITIONAL_DETAILS = "CLIENT_ADDITIONAL_DETAILS",
    REFERRAL_TREATMENT_DETAILS = "REFERRAL_TREATMENT_DETAILS",
    TEST_1 = "TEST_1",
    TEST_2 = "TEST_2"
}

export interface Form {
    id: number,
    form_template?: FormTemplateResponse,
    form_template_version?: number,
    form_upload: FormUpload | null,
    encounter: Encounter | null,
    created_by: User,
    s3_key: string,
    created_at: string,
    saved_at: string,
    completed_at: string | null,
    deleted_at: string | null,
    event_date?: string,
    manual_encounter?: boolean,
    score: string | null,
    form_fields: any[] | null,
    client: Client,
    edited?: boolean,
}

export interface FormUpload {
    id: number,
    name: string,
    form_type: string,
}

export interface FormRequest {
    roster_id: number,
    completed_at: string,
    score?: string | null,
    client_id: string,
    form_definition_id?: number | null,
}

export interface FormUploadRequest {
    name: string,
    form_type: string,
    form: FormRequest,
}
export interface FormTemplateResponse {
    id: number;
    name: string;
    latestVersion: number;
    codeBinding?: FormCodeBinding;
    rosters: {
        id: number,
        name: string
    }[];
    rosterCodeBindings?: {
        rosters: Roster[]
        codeBinding: RosterFormCodeBinding
    }[]
    createdBy: User;
    createdAt: string;
    updatedAt: string;
    surveyJs: string;
    careJourneySteps: FormCareJourneyStepResponse[];
}

export interface FormSchemaResponse {
    pk: string;
    version: string;
    description: string;
    createdAt: string;
    customerId: string;
    schemaType: string;
    stepName: string;
    schemaTypeId: string;
    schemaTypeName: string;
    jsonSchema: {
        stepSequence?: string[];
    };
}

export interface FormTemplateRequest {
    surveyJs: string;
    name: string;
    rosterIds?: number[];
    codeBinding?: string;
    rosterCodeBindings?: {
        rosterIds: string[];
        codeBinding: string;
    }[]
}

export interface RefreshTemplateFormRequest {
    roster_id: number;
    client_id: string;
    copy_compatible_values?: boolean;
}

export interface FormCareJourneyStepRequest {
    careJourneyTemplateId: string;
    stepId: string;
}

export interface FormCareJourneyStepResponse {
    customerId: string;
    stepName: string;
    schemaGuid: string;
    journeyType?: string;
    templateVersion: number;
    jsonSchema: string | null;
    submittedAt: string;
    currentVersion: boolean;
    supersededByTemplateName: string | null;
    supersededByTemplateId: number | null;
    supersededBySchemaGuid: string | null;
}

export interface UpdateFormTemplateJsonSchemaRequest {
    stepName: string;
    customerId: string;
    jsonSchema: string;
    journeyType: string;
}
